import React, { useMemo } from "react";
import { RefValue } from "@common/types/auditLog";
import { useClasses } from "@api/class.api";
import { ClassAvatarGroup } from "@components/avatar/ClassAvatarGroup";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import styles from "./HistoryClass.module.scss";

interface HistoryClassProps {
    value: RefValue;
    field: string;
}

export const HistoryClass: React.FC<HistoryClassProps> = ({ value, field }) => {
    const { classesMap } = useClasses();

    const display = useMemo(() => {
        if (field !== "classIds") {
            return null;
        }

        if (value.value === null || value.value === undefined) {
            return <EmptyValue />;
        }

        const ids: string[] = Array.isArray(value.value)
            ? value.value
            : [value.value];

        if (ids.length === 0) {
            return <EmptyValue />;
        }

        const savedLabels = (value.valueLabel ?? "")
            .split(", ")
            .filter(Boolean);

        const resolvedClasses = ids.map((id, index) => ({
            id,
            classEntity: classesMap.get(id),
            savedLabel: savedLabels[index] ?? id,
        }));

        const classes = resolvedClasses
            .map((r) => r.classEntity)
            .filter((c) => !!c);

        return (
            <div className={styles.container}>
                <ClassAvatarGroup classes={classes} max={3} />
            </div>
        );
    }, [field, value, classesMap]);

    return display;
};
